module.exports = __webpack_public_path__ + "img/distractor-robot-mask.854a1c90.png";